import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';

import {ProductRoutingModule} from './product-routing.module';
import {ProductComponent} from './product/product.component';
import {FilterSidebarModule} from './filter-sidebar/filter-sidebar.module';
import {ProductListingModule} from './product-listing/product-listing.module';
import {ComponentsLibraryModule} from '../components-library/components-library.module';
import {ProductFilterSidebarModule} from './product-filter-sidebar/product-filter-sidebar.module';
import {ChipsFilterComponent} from './chips-filter/chips-filter.component';

// import { PipeModule } from '../pipe/pipe.module';


@NgModule({
	declarations: [
		ProductComponent,
		ChipsFilterComponent
	],
	imports: [
		CommonModule,
		ProductRoutingModule,
		FilterSidebarModule,
		ProductListingModule,
		ComponentsLibraryModule,
		ProductFilterSidebarModule,
		NgOptimizedImage,


	],
	exports: [
		ProductComponent,
		ChipsFilterComponent
	]
})
export class ProductModule { }
